export default function({ dispatch, commit }, params) {
    commit('startedAuthentication')

    // POST /auth/change/email
    return dispatch('post', {
        url: '/auth/change/email',
        data: params
    }, {
        root: true
    })
    .then((response) => {
        commit('finishedAuthentication')
        return response
    })
    .catch((error) => {
        commit('finishedAuthentication')
        return error
    })
}
